import { EyeOutlined, LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Row,
  Col,
  Table,
  Empty,
  Button,
  Input,
  Select,
  Checkbox,
  notification,
  Form,
  Popover,
} from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { ModalExportacion } from "../../../components/Administrador/ModalExportacion/ModalExportacion";
import { useProyectos } from "../../../hooks/useProyectos";
import { cantidadRegistros } from "../../../utils/dataSelectOptions";
import { ModalBeneficiarios } from "./modal-beneficiarios";
import { VerMasProyectos } from "./VerMasProyectos";
import { BreadCrumbAdmin } from "../../../components/Administrador/Breadcrumb/Breadcrumb";
import apiParticipantes from "../../../api/Participantes/api-participantes";
import { TemplateContext } from "../../../utils/template_context";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { ReactComponent as IconFlechareg } from "../../../assets/flecha_reg.svg";
import getStorageUser from "../../../middlewares/GetStorageUser"

export const Proyectos = () => {
  let {
    proyectos,
    setProyectos,
    cambiarCantidadPaginas,
    cantidadPaginas,
    handleLineaChange,
    obtenerLineaConvocatoria,
    obtenerProyectos,
    categoriasLinea,
    lineaConvocatorias,
    loading,
    filtros,
    setFiltros,
    buscarFiltros,
    limpiarFiltros,
    totalregistrosAceptado,
    totalregistrosPorevaluar,
    totalregistrosEvaluado
  } = useProyectos();

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    //obtenerProyectos();
    getUser();
    obtenerLineaConvocatoria();
  }, []);

  const ref = useRef<any>();

  const TipoDocumento: any = {
    "1": "CC",
    "3": "CC",
    "2": "NIT",
  }
  // colors state of postulation
const coloresEstado: any = {
  Aceptado: "#00904C",
  "Por evaluar": "#F28C02",
  "Evaluado": "#6435C9"
};
  const [user, setUser] = useState<any>({});
  const [juradosCriterios, setJuradosCriterios] = useState([])
  const sumatoriaTotal = juradosCriterios.reduce((total, j) => {
    return total + j.criterios.reduce((criterioTotal, c) => criterioTotal + c.nota, 0)/juradosCriterios.length;
  }, 0);

  const context = useContext(TemplateContext);
  const columns: any = [
    {
      title: "No.",
      width: 40,
      fixed: context.device === "lg" ? "left" : false,
      key: "index",
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Nombre de proyecto",
      width: 300,
      fixed: context.device === "md" ? "left" : false,
      render: (data: any) =>
      <span style={{whiteSpace: "pre-line"}}>
        {data?.nombre_propuesta}
      </span>,
    },
    {
      title: "Código",
      width: 80,
      render: (data: any) => <span>{data?.radicado}</span>,
    },
    {
      title: "Estado",
      key: "estado",
      width: 80,
      render: (data: any) => <span style={{ color: coloresEstado[data?.estado] }}>{data?.estado}</span>,
    },
    {
      title: "Linea convocatoria",
      ellipsis: true,
      width: 300,
      render: (data: any) => {
        return <span style={{whiteSpace: "pre-line"}}>{data?.linea_convocatoria}</span>;
      },
    },
    {
      title: "Categoría",
      width: 150,
      render: (datos: any) => {
        return (
          <>
            <span style={{whiteSpace: "pre-line"}}>{datos.categoria_linea_convocatoria}</span>
          </>
        );
      },
    },
    {
      title: "Tipo de Documento",
      width: 100,
      render: (data: any) => <span>{TipoDocumento[data?.postulacion?.tipo_participante]}</span>,
    },
    {
      title: "Documento",
      width: 100,
      render: (data: any) => <span>{data?.postulacion?.numero_documento_participante}</span>,
    },
    {
      title: "Puntaje final",
      width: 100,
      whiteSpace: "nowrap",
      className: "white-space-nowrap",
      style: {whiteSpace: "nowrap"},
      render: (data: any) => <span>{data?.postulacion?.nota_final}</span>,
      fixed: context.device === "lg" ? "right" : false,
    },
    {
      title: () => (
        <Row>
          <Col span={24} className="justify-content-center">
            Ver
          </Col>
        </Row>
      ),
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any) => (
        <>
          <Row>
            <Col span={24} className="justify-content-center">
              <EyeOutlined
                onClick={() => verMas(datos)}
                />
            </Col>
          </Row>
        </>
      ),
    },
    /*{
      title: () => (
        <Row className="width-100">
          <Col span={24} className="justify-content-center">
            Seleccionar
          </Col>
        </Row>
      ),
      fixed: context.device === "lg" ? "right" : false,
      render: (datos: any, record: any, idx: number) => (
        <>
          {datos.estado !== "Beneficiario" && (
            <Row className="width-100">
              <Col span={24} className="justify-content-center items-align-center mb-0 ">
                <Form ref={ref}>
                  <Form.Item name="select" className="mb-0 align-items-center">
                    <Checkbox
                      checked={datos.checked}
                      onChange={(e) => addProyectos(e.target.checked, datos)}
                    ></Checkbox>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          )}
        </>
      ),
    },*/
  ];

  const [verMasOpen, setVerMasOpen] = useState(false);
  const [datos, setDatos] = useState({
    nombre_propuesta: "",
    radicado: "",
    linea_convocatoria: "",
    categoria_linea_convocatoria: [{ text: "" }],
    jurados: [],
  });
  const verMas = (datos: any) => {
    setVerMasOpen(true);
    setDatos(datos);
  };

  const [proyectosBeneficiarios, setProyectosBeneficiarios] = useState<any>([]);
  const addProyectos = (value: any, datos: any) => {
    let proyectosFilter = proyectos.map((x: any) => {
      if (x.index === datos.index) {
        return {
          ...x,
          checked: value,
        };
      }

      return {
        ...x,
      };
    });
    setProyectos(proyectosFilter);
  };

  const itemRenderTable = (current: any, type: any, originalElement: any) => {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingRight: "2px" }}
          />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined
            className="font-color-051923bf"
            style={{ display: "inline-flex", paddingLeft: "2px" }}
          />
        </span>
      );
    }
    return originalElement;
  };

  /* **** MODAL **** */
  const opcionesSelect = [
    { id: 1, nombre: "Proyectos Beneficiarios", value: "Beneficiario" },
    { id: 2, nombre: "Proyectos No Beneficiarios", value: "No Beneficiario" },
  ];

  const [openModal, setOpenModal] = useState(false);
  const openModalExportar = () => setOpenModal(true);

  const openNotification = ({ titulo, descripcion, placement }: any) => {
    notification.info({
      message: titulo,
      description: descripcion,
      placement,
    });
  };

  const [openModalBeneficiarios, setOpenModalBeneficiarios] = useState(false);
  const planillas = async () => {
    console.log('entro')
  };
  const beneficiarios = async () => {
    let proyectosSeleccionados = proyectos.filter(
      (x: any) => x.checked == true
    );
    setProyectosBeneficiarios(proyectosSeleccionados);
    if (proyectosSeleccionados.length !== 0) {
      try {
        let postulaciones = proyectosSeleccionados.map((x: any) => {
          return {
            id_postulacion: x.id_postulacion,
          };
        });

        let payload = {
          estado: "Beneficiario",
          postulaciones,
        };

        await apiParticipantes.actualizarEstadoPostulacion(payload);
        obtenerProyectos();
        setOpenModalBeneficiarios(true);
      } catch (error) {
        console.log(error);
      }
    } else {
      openNotification({
        titulo: "No hay proyectos selccionados",
        descripcion: "Seleccione proyectos beneficiarios para continuar",
        placement: "bottomRight",
      });
    }
  };

  const routes = [
    { nombre: "Gestión jurados" },
    { nombre: "Resultado evaluación" },
  ];

  return (
    <div className="background-color-F7FBFF h-100">
      <BreadCrumbAdmin routes={routes} />
      <div className="container-fluid ps-md-4 pe-md-4 main-c">
        <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
          Resultado de evaluación
        </div>

        <div className="sombra_card" style={{ marginBottom: "20px" }}>
          <div>
            <div className="header_card">
              <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                Buscar{" "}
              </div>
            </div>
            <div className="body_card">
              <div className="row">
                <div className="row mb-3">
                  <div className="col-12 pb-2 ">
                    <label className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B pb-2">Filtrar línea convocatoria</label>
                  </div>
                  <div>
                    <Select
                      showSearch
                      optionFilterProp="children"
                      suffixIcon={<FlechaSelect />}
                      value={filtros.linea_convocatoria}
                      size="large"
                      style={{ width: "100%" }}
                      placeholder="Seleccionar..."
                      onChange={handleLineaChange}
                    >
                      {lineaConvocatorias.slice().reverse().filter(({ nombre }: any) => !nombre.includes('- SM') && !nombre.includes('- MCM')).map(({ id, nombre }: any) => (
                        <Select.Option key={id} value={id}>{nombre}</Select.Option>
                      ))}
                    </Select>
                    {console.log(user, 'user')}
                    { user.documento == '1152462177' && (
                      <Select
                        showSearch
                        optionFilterProp="children"
                        suffixIcon={<FlechaSelect />}
                        value={filtros.linea_convocatoria}
                        size="large"
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        onChange={handleLineaChange}
                      >
                        {lineaConvocatorias.slice().reverse().map(({ id, nombre }: any) => (
                          <Select.Option key={id} value={id}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-blanco-radius m-0"
                onClick={buscarFiltros}
              >
                Buscar
              </Button>
            </div>
          </div>
        </div>

        <div
          className="row-shadow"
          style={{ marginBottom: "6%", marginTop: "16px" }}
        >
          <div className="col-12">
            <div className="row">
              <div className="my-scrollable-div col-12 col-md-12 d-flex justify-content-md-end justify-content-between align-content-center align-items-center mb-3" style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%' }}>
                <div className="d-flex justify-content-end mx-2 font-color-6435C9">
                  Evaluado :{" "}
                    <span className="font-color-6435C9">{totalregistrosEvaluado}</span>
                </div>
                <div className="d-flex justify-content-end mx-2 font-color-F28C02">
                  Por evaluar :{" "}
                    <span className="font-color-F28C02">{totalregistrosPorevaluar}</span>
                </div>
                <div className="d-flex justify-content-end mx-2 font-color-00904C">
                  Aceptado :{" "}
                    <span className="font-color-00904C">{totalregistrosAceptado}</span>
                </div>
                <div className="d-flex justify-content-end">
                  <div>
                    Total:{" "}
                    <span className="font-color-F28C02">
                      {proyectos.length}
                    </span>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-end registos-adminconvocatoria"
                  style={{ width: 200 }}
                >
                  <label className="font-family-Montserrat-Regular  font-size-9px font-color-7E7E7E pe-2 d-flex justify-content-end">
                    Registros por página
                  </label>
                  <Dropdown
                    className="select-registros-adminconvocatoria no-margin justify-content-center d-flex"
                    defaultValue={cantidadPaginas}
                    options={cantidadRegistros}
                    icon={<IconFlechareg/>
                    }
                    onChange={(e, { value }) =>
                      cambiarCantidadPaginas(e, value)
                    }
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No se han diligenciados datos para está sección"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadPaginas,
                  }}
                  dataSource={proyectos}
                  columns={columns}
                  size="small"
                  bordered={false}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-sticky-footer justify-content-flex-end">
        <div className="justify-content-flex-end">
        </div>
        <div className="justify-content-end">
          <Button className="button-gray-ghost" onClick={openModalExportar}>
            Exportar datos
          </Button>
          <Button className="button-gray-ghost" onClick={planillas}>
            Exportar planillas
          </Button>
          <Button className="button-azul-radius ms-1" onClick={beneficiarios}>
            Guardar Beneficiarios
          </Button>
        </div>
      </div>

      {openModal && (
        <ModalExportacion
          openModal={openModal}
          setOpenModal={setOpenModal}
          opcionesSelect={opcionesSelect}
          modulo="Postulaciones"
          consulta="1"
        />
      )}

      {openModalBeneficiarios && (
        <ModalBeneficiarios
          openModal={openModalBeneficiarios}
          proyectosBeneficiarios={proyectosBeneficiarios.filter(
            (x: any) => x.checked === true
          )}
          setOpenModal={setOpenModalBeneficiarios}
          obtenerProyectos={obtenerProyectos}
          referencia={ref}
        />
      )}

      {verMasOpen && (
        <VerMasProyectos
          openModal={verMasOpen}
          setOpenModal={setVerMasOpen}
          datos={datos}
        />
      )}
    </div>
  );
};
